import React, { useState, useEffect, useMemo } from 'react';
import { CircularProgress } from '@material-ui/core';
import {
  getSessionStorageItem,
  setSessionStorageItemWithExpiration,
  ADVISOR_ACTIVITY_CENTER_KEY,
  ADVISOR_ACTIVITY_CENTER_SUMMARY_DETAILS_KEY,
  ADVISOR_OBJECT_KEY,
  SESSION_STORAGE_ACCOUNT_KEY,
  ACTIVITY_CENTER_FILTER_KEY
} from '../../sessionStorage';
import CaseTable from './SubComponents/CaseTable';
import CaseHeader from './SubComponents/CaseHeader';
import CaseFilters from './SubComponents/CaseFilters';
import Breadcrumb from '../Common/Breadcrumb/Breadcrumb';
import SubmitLinks from '../Common/ActionButtons';
import { Row } from 'react-bootstrap';
import { httpRequest } from '../../httpRequest';
import './ActivityCenter.scss';
import constants from '../../constants';
import { ConvertYesNoToBoolean } from '../Helpers/Formatters/ConvertBoolean';
import { ValidateUserEntitlements } from '../Common/ValidateUserEntitlements';

export default function ActivityCenter(props) {
  let advisorObj = getSessionStorageItem(ADVISOR_OBJECT_KEY);
  let role = advisorObj && advisorObj.role;
  let faList = advisorObj && advisorObj.faOptions;

  const { appGoal, premiumGoal } = props;

  const defaultState = {
    cases: null,
    pageLoading: true,
    casesLoading: null,
    sort: '',
    pageNumber: 1,
    casesPerPage: 10,
    updateCaseTable: false,
    statusCategories: ['Quoting Coverage', 'Completing Application', 'Application Review', 'Policy Delivery', 'Coverage Active', 'Closed'],
    showDetailView: false,
    detailViewLoading: false,
    selectedCaseDetails: null,
    filters: {
      caseOrIllustration: 'all',
      officeFa: '',
      officeAccount: '',
      branchOptions:'',
      faNum:'',
      officeNum:'',
      referenceID: '',
      ticketNumber: '',
      advisor: '',
      firstName: '',
      lastName: '',
      caseStatus: '',
      IllustrationStatusCategory: '',
      caseType: '',
      createdDateStart: '',
      createdDateEnd: '',
      caseNumber:'',
      carrier:'',
      plan:'',
      policy:'',
      residentState:'',
      deathBenefitMin:null,
      deathBenefitMax:null,
      premiumAmountMin:null,
      premiumAmountMax:null,
      reg60:'',
      esign:'',
      replacement:'',
      showFilter: false
    },
    submissionGoal: {
      appGoal: appGoal,
      premiumGoal: premiumGoal,
    },
  };

  const [activityCenterState, updateActivityCenterState] = useState(defaultState);
  const firstFaOption = advisorObj && advisorObj.faOptions && advisorObj.faOptions[0] && advisorObj.faOptions[0].id && advisorObj.faOptions[0].id.split('-');
  const defaultOfficeNumber = firstFaOption && firstFaOption.length === 2 ? firstFaOption[0] : "";
  const defaultFaNumber = firstFaOption && firstFaOption.length === 2 ? firstFaOption[1] : "";
  const officeNumber = (activityCenterState.filters && activityCenterState.filters.officeFa != "") ? "" : activityCenterState.filters && activityCenterState.filters.officeNum;
  const officeNum = officeNumber != "" ? officeNumber : (activityCenterState.filters && activityCenterState.filters.officeFa && activityCenterState.filters.officeFa.split("-")[0] || defaultOfficeNumber);
  const faNumber = (activityCenterState.filters && activityCenterState.filters.officeFa != "") ? "" : activityCenterState.filters && activityCenterState.filters.faNum;
  const faNum = faNumber != "" ? faNumber : (activityCenterState.filters && activityCenterState.filters.officeFa && activityCenterState.filters.officeFa.split("-")[1] || defaultFaNumber);
  const defaultView = officeNumber === "" && faNumber === "" && (activityCenterState.filters && activityCenterState.filters.officeFa === "");
  const isValidateUserEntitlement = useMemo(() => ValidateUserEntitlements(faList, role, officeNum, faNum), [officeNum, faNum]);

  const openCaseDetail = (referenceID) => {
    props.history.push(`/ActivityCenter/${referenceID}`);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  let timeout = null;
  const filterUpdate = (fullFilterObject) => {
    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(() => updateActivityCenterState({ ...activityCenterState, updateCaseTable: true, filters: fullFilterObject }), 500);
  };

  const goalUpdate = (updateObj) => {
    updateActivityCenterState({ ...activityCenterState, submissionGoal: { ...updateObj } });
  };

  let debounce = null;
  useEffect(() => {
    let isSubscribed = true;
    if (debounce) {
      clearTimeout(debounce);
    }

    const casesFromSession = getSessionStorageItem(ADVISOR_ACTIVITY_CENTER_KEY);
    const summaryDetailsFromSession = getSessionStorageItem(ADVISOR_ACTIVITY_CENTER_SUMMARY_DETAILS_KEY);
    const baseAddress = process.env.REACT_APP_COVR_SERVICES_URL;
    const filterFromSession = getSessionStorageItem(ACTIVITY_CENTER_FILTER_KEY);
    const isDifferentFilter = filterFromSession && JSON.stringify(activityCenterState.filters) !== JSON.stringify(filterFromSession);
    let requiredToFetchACCaseInfo = (!casesFromSession || summaryDetailsFromSession || activityCenterState.updateCaseTable || isDifferentFilter) && isValidateUserEntitlement;

    if (requiredToFetchACCaseInfo) {
      debounce = setTimeout(() => getActivityCenterDetails(() => isSubscribed), 700);

      const getActivityCenterDetails = () => {
        if (casesFromSession && summaryDetailsFromSession) {
          updateActivityCenterState({
            ...activityCenterState,
            cases: casesFromSession,
            casesLoading: true,
            pageLoading: !summaryDetailsFromSession,
          });
        } else {
          updateActivityCenterState({ ...activityCenterState, casesLoading: true, pageLoading: !summaryDetailsFromSession });
        }

          const queryParams = {
              userRole: role.toLowerCase(),
              officeNumber: officeNum,
              faNumber: faNum,
              branchNumber: activityCenterState.filters && activityCenterState.filters.officeAccount && activityCenterState.filters.officeAccount.split("-")[0] || "",
              accountNumber: activityCenterState.filters && activityCenterState.filters.officeAccount && activityCenterState.filters.officeAccount.split("-")[1] || "",
              caseStatusCategory: activityCenterState.filters && activityCenterState.filters.caseStatus !== "all" ? activityCenterState.filters.caseStatus : "",
              illustrationStatusCategory: activityCenterState.filters && activityCenterState.filters.IllustrationStatusCategory !== "all" ? activityCenterState.filters.IllustrationStatusCategory : "",
              firstOrBusinessName: activityCenterState.filters && activityCenterState.filters.firstName,
              lastName: activityCenterState.filters && activityCenterState.filters.lastName,
              faFirstName: "",
              faLastName: "",
              referenceID: activityCenterState.filters && activityCenterState.filters.referenceID,
              ticketNumber: activityCenterState.filters && activityCenterState.filters.ticketNumber,
              policyNumber: activityCenterState.filters && activityCenterState.filters.policy,
              status: "",
              state: activityCenterState.filters && activityCenterState.filters.residentState,
              deathBenefitMinimum: activityCenterState.filters && activityCenterState.filters.deathBenefitMin ? parseFloat(activityCenterState.filters.deathBenefitMin) : null,
              deathBenefitMaximum: activityCenterState.filters && activityCenterState.filters.deathBenefitMax ? parseFloat(activityCenterState.filters.deathBenefitMax) : null,
              premiumAmountMinimum: activityCenterState.filters && activityCenterState.filters.premiumAmountMin ? parseFloat(activityCenterState.filters.premiumAmountMin) : null,
              premiumAmountMaximum: activityCenterState.filters && activityCenterState.filters.premiumAmountMax ? parseFloat(activityCenterState.filters.premiumAmountMax) : null,
              carrierName: activityCenterState.filters && activityCenterState.filters.carrier,
              planName: activityCenterState.filters && activityCenterState.filters.plan,
              createdDateStart: activityCenterState.filters && activityCenterState.filters.createdDateStart,
              createdDateEnd: activityCenterState.filters && activityCenterState.filters.createdDateEnd,
              pageNumber: activityCenterState.pageNumber,
              itemsPerPage: activityCenterState.casesPerPage,
              quoteType: activityCenterState.filters && activityCenterState.filters.caseType !== "all" ? activityCenterState.filters.caseType : "",
              isIllustration: activityCenterState.filters && (activityCenterState.filters.caseOrIllustration === 'all' ? null : activityCenterState.filters.caseOrIllustration === 'Insurance Case' ? false : true),
              isReplacement: activityCenterState.filters && ConvertYesNoToBoolean(activityCenterState.filters.replacement),
              isReg60: activityCenterState.filters && ConvertYesNoToBoolean(activityCenterState.filters.reg60),
              isESign: activityCenterState.filters && ConvertYesNoToBoolean(activityCenterState.filters.esign),
              externalUserID: null,
              officeFAList: faList && faList.map(fa => fa.id),
              defaultView: defaultView
          };
          httpRequest.post(`${baseAddress}/api/MorganStanley/GetCases`, queryParams ).then((data) => {
            if(data.success && data.content.length > 0){
              setSessionStorageItemWithExpiration(ADVISOR_ACTIVITY_CENTER_KEY, data.content[0], 60);
            setSessionStorageItemWithExpiration(ACTIVITY_CENTER_FILTER_KEY, activityCenterState.filters, 60);

            updateActivityCenterState({
                ...activityCenterState,
                cases: data.content[0],
                casesLoading: false,
                pageLoading: false,
                updateCaseTable: false,
              });
            }
            else{
              updateActivityCenterState({
                ...activityCenterState,
                cases: '',
                casesLoading: false,
                pageLoading: false,
                updateCaseTable: false,
              });
            }
          }).catch(() => {
            updateActivityCenterState({
              ...activityCenterState,
              cases: '',
              casesLoading: false,
              pageLoading: false,
              updateCaseTable: false,
            });
          });
      };
    } else {
      if (!isValidateUserEntitlement) {
        sessionStorage.removeItem(ADVISOR_ACTIVITY_CENTER_KEY);
      }
      updateActivityCenterState({
        ...activityCenterState,
        cases: isValidateUserEntitlement ? (casesFromSession || {}) : {},
        casesLoading: false,
        pageLoading: false,
        updateCaseTable: false,
      });
    }

    return () => {
      clearTimeout(debounce);
      isSubscribed = false;
    };
  }, [activityCenterState.updateCaseTable]);

  return activityCenterState.pageLoading ? (
    <div className="d-flex justify-content-center p-5">
      <CircularProgress />
    </div>
  ) : (
    <ActivityCenterView
      openCaseDetail={openCaseDetail}
      stateUpdate={updateActivityCenterState}
      state={activityCenterState}
      filterUpdate={filterUpdate}
      appGoal={appGoal}
      premiumGoal={premiumGoal}
      goalUpdate={goalUpdate}
      permission={props.permission}
      role={role}
      faList={faList}
      defaultState={defaultState}
    />
  );
}

function ActivityCenterView(props) {
  const [opsAdvisor, setOpsAdvisor] = useState([]);

  useEffect(() => {
    let baseAddress = process.env.REACT_APP_COVR_SERVICES_URL;
    let sessionStorage = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
    let oneClickAccountId = sessionStorage && sessionStorage.account && sessionStorage.account.oneClickAccountId;

    if ([constants.risRole, constants.opsRole].includes(role)) {
      httpRequest.get(`${baseAddress}/api/advisor/GetAccountAgents?oneClickAccountId=${oneClickAccountId}&role=FA`)
        .then((data) => setOpsAdvisor(data.filter((advisor) => advisor.firstName || advisor.lastName)))
        .catch((error) => console.log('GetAccountAgents', error));
    }
  }, []);

  const {  stateUpdate, state, openCaseDetail, filterUpdate, goalUpdate, role, faList, defaultState} = props;
  
  return (
    <React.Fragment>      
      <div className="mb-3">
        <Breadcrumb breadcrumbLinks={[{ name: 'HOME', href: '/' }]} currentPage={'ACTIVITY'} />
      </div>

      <CaseHeader
        stateUpdate={goalUpdate}
        appGoal={state.submissionGoal && state.submissionGoal.appGoal}
        premiumGoal={state.submissionGoal && state.submissionGoal.premiumGoal}
      />

      <Row className='mt-n2'>
          <SubmitLinks />
      </Row>

      <CaseFilters state={state.filters} advisorList={opsAdvisor} defaultState={defaultState} filterUpdate={filterUpdate} disabled={state.casesLoading} role={role} faList={faList} />

      <CaseTable state={state} openCaseDetail={openCaseDetail} stateUpdate={stateUpdate} />
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/ActivityCenter/ActivityCenter.js